<script>
  import { onMount } from 'svelte';
  import ui from '/stores/UI';
  import { undoDraft, redoDraft } from 'stores/Draft';

  onMount(() => {
    document.body.addEventListener('keydown', (event) => {
      keydown(event);
    });
  });

  function keydown(e) {
    if (e.key === 'Escape') {
      ui.update((temp) => {
        temp.selectedMenu = -1;
      });
    }
    if (e.ctrlKey === true && e.key === 'z') {
      undoDraft();
    } else if (e.ctrlKey === true && e.key === 'y') {
      redoDraft();
    }
  }
</script>
